import type MediaPreview from "@components/Atoms/Image/modalImage/MediaPreview";
import ModalToOpenService from "@core-ui/ContextServices/ModalToOpenService/ModalToOpenService";
import ModalToOpen from "@core-ui/ContextServices/ModalToOpenService/model/ModalsToOpen";
import { AttachmentTile } from "@ext/agent/components/panel/AttachmentTile";
import { Tooltip, TooltipContent, TooltipTrigger } from "@ui-kit/Tooltip";
import type { ComponentProps } from "react";

type Props = {
	name: string;
	src: string | null;
	onRemove?: () => void;
	onDownload?: () => void;
	isDownloading?: boolean;
};

const openMediaPreview = (name: string, src: string, onDownload?: () => void) =>
	ModalToOpenService.setValue<ComponentProps<typeof MediaPreview>>(ModalToOpen.MediaPreview, {
		id: name,
		src,
		onDownload,
		onClose: () => ModalToOpenService.resetValue(),
	});

export const ImageAttachmentPreview = ({ name, src, onRemove, onDownload, isDownloading }: Props) => (
	<AttachmentTile isDownloading={isDownloading} onDownload={onDownload} onRemove={onRemove}>
		{src && (
			<Tooltip>
				<TooltipTrigger asChild>
					<img
						alt={name}
						className="size-full cursor-zoom-in object-cover"
						onClick={() => openMediaPreview(name, src, onDownload)}
						src={src}
					/>
				</TooltipTrigger>
				<TooltipContent>{name}</TooltipContent>
			</Tooltip>
		)}
	</AttachmentTile>
);
